import Modal from './TransferManaModal.container'

export default Modal
